import { Controller } from 'stimulus'

const SLIDE_MS = 300

// Cancel for the class join/edit reservation form (card and modal).
// Slides the form up, then clears the join form containers so Join/Edit return.
export default class extends Controller {
  cancel(event) {
    event.preventDefault()
    event.stopPropagation()

    this.slideUp().then(() => this.clearJoinForms())
  }

  clearJoinForms() {
    const container = this.element.parentElement
    if (!container?.id) {
      this.element.remove()
      return
    }

    const otherId = container.id.startsWith('modal_join_form_')
      ? container.id.replace(/^modal_/, '')
      : `modal_${container.id}`

    container.innerHTML = ''
    const other = document.getElementById(otherId)
    if (other) other.innerHTML = ''
  }

  slideUp() {
    return new Promise((resolve) => {
      if (this.element.classList.contains('is-sliding-out')) {
        resolve()
        return
      }

      let resolved = false
      const done = () => {
        if (resolved) return
        resolved = true
        resolve()
      }

      this.element.classList.add('is-sliding-out')
      this.element.addEventListener('animationend', done, { once: true })
      window.setTimeout(done, SLIDE_MS + 50)
    })
  }
}
